import { KeyRecoilProps } from '@/shared/model';
import useTabECGEventUIEffect from './useTabECGEventUIEffect';

/**
 * Keeps the ECG events tab's modal and date-picking state consistent as the reviewer changes strips, tabs and modals, rendering nothing itself.
 *
 * @param keyRecoil - Store record key identifying which report tab's UI state this effect drives.
 * @returns Null, because this effect-only component renders no markup.
 */
export const TabECGEventUIEffect = ({ keyRecoil }: KeyRecoilProps): null => {
  useTabECGEventUIEffect({ keyRecoil });
  return null;
};
